async function fetchAndExtractDivContent(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Erro ao obter a página: ${response.statusText}`);
        }
        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const div = doc.querySelector('div[data-manual-modal-images]');
        if (!div) {
            throw new Error('Div com o atributo data-manual-modal-images não encontrada.');
        }
        return div.innerHTML;
    } catch (error) {
        console.error('Erro:', error);
    }
}

const ManualModalInit = () => {
    const manualLinks = document.querySelectorAll('[href*="?manual-modal"]');
    if (manualLinks.length > 0){
        manualLinks.forEach((link, idx) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const element = event.currentTarget;
                element.classList.add('link-disabled');
                const url = element.getAttribute('href');
                fetchAndExtractDivContent(url)
                    .then(content => {
                        const insertEl = document.createElement('div');
                        insertEl.setAttribute('data-manual-page', url);
                        insertEl.innerHTML = content;
                        document.querySelector('body').appendChild(insertEl);

                        // init lightbox
                        const lightbox_modal = new PhotoSwipeLightbox({
                            closeSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
                            bgOpacity: 1,
                            arrowPrevTitle: theme.strings.previous,
                            arrowNextTitle: theme.strings.next,
                            closeTitle: theme.strings.close,
                            allowPanToNext: false,
                            allowMouseDrag: true,
                            wheelToZoom: false,
                            returnFocus: true,
                            zoom: false,
                            gallery: '[data-manual-page]',
                            children: 'a',
                            mainClass: 'manul-modal',
                            pswpModule: () => import(theme.settings.pswpModule)
                        });
                        lightbox_modal.init();

                        lightbox_modal.on('close', () => {
                            const modalElements = document.querySelectorAll('[data-manual-page]');
                            if(modalElements.length > 0){
                                modalElements.forEach((removeElement) => {
                                    removeElement.remove();
                                })
                            }
                        })

                        setTimeout(() => {
                            const firstLink = document.querySelector('[data-manual-page] a:first-child').click();
                            element.classList.remove('link-disabled');
                        }, 500);
                    });
            })
        })
    }
}

const PartsModalInit = () => {
    const partsLinks = document.querySelectorAll('[href*="?parts-modal"]');
    if (partsLinks.length > 0){
        partsLinks.forEach((link, idx) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const element = event.currentTarget;
                element.classList.add('link-disabled');
                const url = element.getAttribute('href');
                fetchAndExtractDivContent(url)
                    .then(content => {
                        const insertEl = document.createElement('div');
                        insertEl.setAttribute('data-parts-page', url);
                        insertEl.innerHTML = content;
                        document.querySelector('body').appendChild(insertEl);

                        // init lightbox
                        const lightbox_modal = new PhotoSwipeLightbox({
                            arrowPrevSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
                            arrowNextSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>',
                            closeSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
                            bgOpacity: 1,
                            arrowPrevTitle: theme.strings.previous,
                            arrowNextTitle: theme.strings.next,
                            closeTitle: theme.strings.close,
                            // allowPanToNext: false,
                            // allowMouseDrag: true,
                            // wheelToZoom: false,
                            // returnFocus: true,
                            zoom: false,
                            gallery: '[data-parts-page]',
                            children: 'a',
                            mouseMovePan: true,
                            initialZoomLevel: 'fill',
                            secondaryZoomLevel: 'fill',
                            maxZoomLevel: 'fill',
                            mainClass: 'parts-modal',
                            pswpModule: () => import(theme.settings.pswpModule)
                        });
                        lightbox_modal.init();

                        lightbox_modal.on('close', () => {
                            const modalElements = document.querySelectorAll('[data-parts-page]');
                            if(modalElements.length > 0){
                                modalElements.forEach((removeElement) => {
                                    removeElement.remove();
                                })
                            }
                        })

                        setTimeout(() => {
                            const firstLink = document.querySelector('[data-parts-page] a:first-child').click();
                            element.classList.remove('link-disabled');
                        }, 500);
                    });
            })
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    ManualModalInit();
    PartsModalInit();
})